$(document).ready(function () {

  (async () => {
      if ('loading' in HTMLImageElement.prototype) {
          const images = document.querySelectorAll("img.lazyload");
          images.forEach(img => {
              img.src = img.dataset.src;
          });
      } else {
          // lazySizes.init(); // lazySizes применяется при обработке изображений, находящихся на странице.
      }
  })();


  var fired = false;

  window.addEventListener('scroll', () => {
      if (fired === false) {
          fired = true;

          setTimeout(() => {

          }, 1000)
      }
  });
  document.querySelectorAll('.mainContainer__offer-single .module').forEach(function(el, i) {
    el.classList.remove('module');
    el.classList.add('single__module');
  });

  document.querySelectorAll('.offerSingleDetails__slider .slick-arrow').forEach(function(el, i) {
    el.innerHTML = '';
  });

  $('.offerSingleDetails__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    asNavFor: '.offerSingleDetails__nav'
  });
  $('.offerSingleDetails__nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.offerSingleDetails__slider',
    focusOnSelect: true
  });

  $('.modules__inner.owl-carousel').owlCarousel({
    items: 1,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    mouseDrag: true,
    margin: 25,
    responsive: {
      1024: {
        items: 5
      }
    }
  });


  $('[data-front-slider]').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 1000,
    fade: true,
    useTransform: true,
    // cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    adaptiveHeight: true,
    appendArrows: $('.sliderHome__nav'),
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>'
  });


  // var wow = new WOW();
  // wow.init();

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  $(".sliderOwl__arrowDown").on("click", function (e) {
    e.preventDefault();
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.intro').offset().top - 100
    }, 1500, 'swing');
  });

  $('#arrowMap').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.contactPlaceMap').offset().top - 200
    }, 1500, 'swing');
  });

	var hash= window.location.hash

	// if ( hash == '' || hash == '#' || hash == undefined ) return false;


	      var target = $(hash);

				// console.log(target);

	      headerHeight = 120;
	      // target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				// console.log(hash);

				if (target.length) {
	        $('html,body').stop().animate({
	          scrollTop: target.offset().top - 125 //offsets for fixed header
	        }, 'linear');
	      }

});

$(document).ready(function() {
  $(window).scroll(function(){
    if($(window).scrollTop() > 45 ) {
      $("header").addClass('fixed');
    } else {
      $("header").removeClass('fixed');
    }
  });
  $('.banner__mouse').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.offer').offset().top - 180
    }, 1500, 'swing');
  });
  var rellax = new Rellax('.rellax', {
    speed: -4,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  });
  var rellax2 = new Rellax('.rellax2', {
    speed: 4,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  });
  inView('.js-animate')
  .on('enter', el => {
      $(el).addClass("css-animate");
  });
  $(".header__mobile_menu, .close_menu").click(function () {
    $(".mobileMenu").toggleClass("active");
  });
  $(window).scroll(function(){
    if($(window).scrollTop() > 300 ) {
      $(".arrow-top").addClass('active');
    } else {
      $(".arrow-top").removeClass('active');
    }
  });
  $(".arrow-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  $(".message__info").click(function(){
    $(".message__info").css("display", "none");
  });
  var owl = $('.banner__wrapper');
  owl.owlCarousel({
    loop: true,
    margin: 0,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    dots: true,
    items: 1,
    mouseDrag: false,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 7000,
    onRefreshed:function(el){

    },
    onInitialized:function(el){

    },
    onChanged:function(el){

    }
  });
  $('.banner__nav_prev').click(function(){
    owl.trigger('prev.owl.carousel');
  });
  $('.banner__nav_next').click(function(){
      owl.trigger('next.owl.carousel');
  });
  $('.galleryHome__inner').owlCarousel({
    loop: true,
    margin: 50,
    navigation: false,
    autoWidth: true,
    center: true,
    dots: true,
    items: 2,
    mouseDrag: true,
    smartSpeed: 1500,
    autoplay: false,
    autoplayTimeout: 7000,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1,
        autoWidth: false,
      },
      1200: {
        items: 3
      }
    }
  });
  $('.video--slider-wrap').slick({
    prevArrow: $('.arrow--slider-prev'),
    nextArrow: $('.arrow--slider-next'),
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: false,
    swipe: true,
    vertical: true,
    dots: false,
    infinite: true
  });
  $('.offer__slider_wrapper')
  .slick({
      prevArrow: $('.offer__slider_prev'),
      nextArrow: $('.offer__slider_next'),
      autoplay: true,
      autoplaySpeed: 8000,
      dots: true,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      cssEase: 'linear'
  });
  $('.content__gallery, .galleryHome__inner').magnificPopup({
    delegate: 'a.openPhoto, a.galleryHome__inner_item',
    type: 'image',
    tLoading: 'Ładowanie #%curr%...',
    mainClass: 'mfp-with-zoom',
    tClose: 'Zamknij',
    removalDelay: 400,
    gallery: {
        enabled: true,
        navigateByImgClick: true,
        tPrev: 'Poprzednie',
        tNext: 'Następne',
        preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
    },
    image: {
        tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
        titleSrc: function (item) {
            return item.el.attr('title');
        }
    }
  });
});

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
$('.video--slider-item').bind('click', function(e) {
    e.preventDefault();
    $('.v-left-area').html('<div id="video--inner" class="video--inner"></div>');
    var player;
    var videoData = $(this).data('videoid');
    player = new YT.Player('video--inner', {
        height: '100%',
        width: '100%',
        videoId: videoData,
        playerVars: {
            showinfo: 0,
            rel: 0
        },
        events: {
            'onReady': function(e) { /* e.target.playVideo(); */ }
        }
    });
});

function onYouTubeIframeAPIReady() {
    if ($('.video--slider-wrap').length > 0) {
        if ($('.video--slider-item').length > 0) {
            $('.video--slider-item').click();
        } else {
            $('.galleryVideo .videoSlider > a:not(.bx-clone)')[0].click();
        }
    }
}
